import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white website-visitors radius-7" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-sm-25 p-lg-30 letter-spacing graphic-month-dashboard-height" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "mb-lg-15 d-sm-flex align-items-center justify-content-between" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "card-title fw-bold mb-0" }, "Gravações mensais")
], -1)
const _hoisted_4 = {
  id: "websiteVisitorsChart",
  class: "chart"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_apexchart, {
          type: "bar",
          height: "385",
          options: _ctx.websiteVisitorsChart,
          series: [{name: 'Quantidade',data: [{x: 'Sucesso', y: _ctx.getDashboardMonthCards.total_success, fillColor: '#1D6FF2'}, {x: 'Erro', y: _ctx.getDashboardMonthCards.total_error, fillColor: '#C33F52'}]}]
        }, null, 8, ["options", "series"])
      ])
    ])
  ]))
}